import { ImpressionSource } from 'src/app/@utils/gtm-tracking/events/trackProductImpressionEvent';
import { Product } from 'src/app/@utils/gtm-tracking/model';
import { removeEmpty } from 'src/app/@utils/remove-empty.helper';

import { ProductSearchViewModel } from '@models/api-search.models';
import { mapToPromotion } from '@utils/gtm-tracking/utils/mapToPromotion';

type TrackableProduct = ProductSearchViewModel &
    Partial<{ list: ImpressionSource; listId: string; quantity: number; location: string; index: number }>;

export const mapToTrackableProduct = (product: TrackableProduct): Product => {
    const {
        productName,
        unitPriceRaw,
        variantNo,
        primaryColor,
        brand,
        webCategoryL1,
        webCategoryL2,
        webCategoryL3,
        webCategoryL4,
        activeSplashes,
        list,
        listId,
        quantity,
        discountAmountRaw,
        index
    } = product;

    return removeEmpty<Product>({
        item_name: productName,
        item_id: variantNo,
        currency: 'DKK',
        price: unitPriceRaw,
        discount: discountAmountRaw,
        item_variant: primaryColor?.text || '',
        item_brand: brand?.text || '',
        item_category: webCategoryL1?.text || '',
        item_category_2: webCategoryL2?.text,
        item_category_3: webCategoryL3?.text,
        item_category_4: webCategoryL4?.text,
        item_list_name: list,
        item_list_id: listId,
        quantity: quantity || 1,
        ...mapToPromotion(activeSplashes),
        index
    }) as Product;
};
